<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- first name -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group
                label="Descrição"
                label-for="v-description"
              >
                <b-form-input
                  id="v-description"
                  v-model="item.descricao"
                  data-cy="input-descricao"
                  :state="errors.length > 0 ? false : null"
                  placeholder="descrição"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="error-descricao"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group
                label="Tipo Protocolo"
                label-for="v-tipo"
              >
                <v-select
                  v-model="item.tipo"
                  data-cy="select-tipo-protocolo"
                  label="descricao"
                  :state="errors.length > 0 ? false : null"
                  :options="comboTipoProtocolo"
                  :disabled="!canEditOrInsert"
                />
                <small
                  data-cy="error-tipo-protocolo"
                  class="text-danger"
                >{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col
            v-if="item.id"
            cols="12"
          >
            <b-form-group
              label="Ativo"
              label-for="v-check-button"
            >
              <b-form-checkbox
                v-model="item.ativo"
                :checked="item.ativo"
                data-cy="switch-ativo"
                name="check-button"
                switch
                inline
                :disabled="!canEditOrInsert"
              >
                {{ item.ativo ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="verificarPermissao('ROLE_PROT_INSERIR')"
            :permission-edit="verificarPermissao('ROLE_PROT_ATUALIZAR')"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import mixinsGlobal from '@/mixins'
import { verificarPermissao } from '@/auth/utils'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'
import vSelect from 'vue-select'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('itemSettingsModule', {
      item: state => state.item,
    }),
    ...mapState('combosModule', {
      comboTipoProtocolo: state => state.comboTipoProtocolo,
    }),
    canEditOrInsert() {
      return (
        (!this.item.id && this.verificarPermissao('ROLE_PROT_INSERIR'))
        || (this.item.id && this.verificarPermissao('ROLE_PROT_ATUALIZAR'))
      )
    },
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    vSelect,
    ButtonsFormVue,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      verificarPermissao,
      titleForm: 'Cadastro de Itens',
      required,
    }
  },
  async mounted() {
    await this.$store.dispatch('combosModule/loadComboTipoProtocolo')
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
    },
    save() {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.item.id) {
            this.$store
              .dispatch('itemSettingsModule/edit', this.item)
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch('itemSettingsModule/insert', this.item)
              .then(response => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error,
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.$refs.form.reset()
              })
          }
        }
      })
    },
  },
}
</script>
